import React from "react";
import './Filter.scss';

/**
 * Component that encapsulates a label with an input
 *
 * @param {object} props
 */
const Filter = ({ label, className, children }) => {
    return (
        <span className={"Filter" + (className ? ` ${className}` : '')}>
            {label ? <label>{label}</label> : <label>&nbsp;</label>}
            {children}
        </span>
    );
};

export default Filter;
